import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { roundValue } from '../../utils/numberUtils'
import * as st from './imdbScore.module.scss'
import * as badgeSt from './badge.module.scss'
import * as cn from 'classnames'
import { isTreatment } from '../../utils/utils'
import { AtfTreatmentProps } from '../../reducers/features'
import { DpWidgetContext } from '../../utils/dpWidgetContext'

export interface IImdbScoreBadgeProps extends AtfTreatmentProps {
  imdb?: WpsRuntime.atv.wps.ImdbFragmentModelProps
}

export const ImdbScore = ({ imdb, atfTreatment }: IImdbScoreBadgeProps) => {
  const { getString } = React.useContext(DpWidgetContext)
  return imdb && imdb.score &&
  (<Badge className={cn(st.wrapper, {[badgeSt.lightBadge]: isTreatment(atfTreatment,'T1', 'T2', 'T3')})} use={badges.TEXT}>
    <span>IMDb&nbsp;</span>
    <span data-automation-id="imdb-rating-badge" aria-label={getString('DV_DP_ARIA_imdb_rating', { ratingValue: roundValue(imdb.score, 10).toString() })}>{imdb.scoreFormatted}</span>
  </Badge>) || null
}

